/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Failure/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import LabelButton from 'DesignSystem/LabelButton/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Failure({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/Content/Download/DownloadCSV/Content/Failure"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<div
  data-testid="Failure.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<LabelButton
  viewPath={`${viewPath}/LabelButton`}
 text="Something went wrong"
 marginLeft={0}
 marginTop={2}
/>
<button
  data-testid="Failure.Horizontal"
  data-view-path={viewPath}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../DownloadAction'))}
 {...isHoveredBind}
 className={`views-block ${styles.Horizontal}`}
>
<LabelButton
  viewPath={`${viewPath}/LabelButton`}
 text="Try again"
 color="#137ec5"
 marginLeft={0}
 marginTop={2}
/>
</button>
</div>
{children}
</React.Fragment>)
}